export default __webpack_public_path__ + "media/images/promare/header-promare-colour-2dc6d0ea8460d926ccd1d23727be2b90.jpg";